import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import { useNotification } from "@hooks/useNotification";
import "@css/pages/hoursPlanner/hoursPlanner.css";
import ModalDelete from "@components/modals/modalDelete";
import { EmployerCourse } from "@services/all.services";
import { NotificationUtil } from "@utils/notification.utils";

const ModalDeleteCourse = ({ isOpen, toggle, idParcours, onClickClose }) => {
  const { t } = useTranslation("pages.employés.parcours&Certifications")
  const { showError, showSuccess } = useNotification();

  const deleteCourse = () => {
    EmployerCourse.deleteById(idParcours)
      .then((response) => {
        // if(!response.data.success){
        //   showError(response.data.message)
        // }else 
        if (response.data?.data?.success){
          showSuccess("delete_action_success", { object: "course" });
          NotificationUtil.emploieCourseUpdate(
            response.data.data.data
          );
          onClickClose();
        }else{
          showError("error");
        }
      })
      .catch((e) => {
        console.log(e);
        showError("error");
  });
  };
  
    return (
      <ModalDelete
        isOpen={isOpen}
        toggle={toggle}
        content={t("Êtes-vous sûr de vouloir supprimer ce parcours ?")}
        onCloseModal={onClickClose}
        handleDelete={deleteCourse}
        colorBtn="green"
      />
    );
}

export default memo(ModalDeleteCourse);
